import { Reveal, Overline } from "./Reveal";
import { Placeholder } from "./Placeholder";
import menuImg from "@/assets/menu.png";
import settingImg from "@/assets/breakfast_setting.png";
import teaImg from "@/assets/breakfast_teastation.jpg";
import kitchenetteImg from "@/assets/breakfast_kitchenette.jpg";
import coffeeImg from "@/assets/breakfast_coffee.webp";
import { useLightbox } from "./Lightbox";
import { Leaf, Croissant, Sprout } from "lucide-react";

const OPTIONS = [
  { icon: Croissant, name: "Continental", note: "Classic & indulgent" },
  { icon: Leaf, name: "Vegetarian", note: "Wholesome & nourishing" },
  { icon: Sprout, name: "Vegan", note: "Plant-based & delicious" },
];

export const Breakfast = () => {
  const lightbox = useLightbox();
  return (
  <section id="breakfast" data-testid="breakfast-section" className="py-24 md:py-40">
    <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-14 lg:gap-20 items-center">
      <Reveal className="lg:col-span-6 order-2 lg:order-1">
        <Overline>Breakfast, something for everyone</Overline>
        <h2 className="font-serif font-light tracking-tight leading-[0.95] text-textMain text-4xl md:text-5xl lg:text-6xl mt-6">
          Wake up to a proper spread
        </h2>
        <p className="font-sans text-textMuted leading-relaxed mt-8 max-w-xl">
          Continental breakfast provisions are carefully selected from quality produce, laid out on beautiful tableware. We're proud to offer a delicious range of Continental, Vegetarian and Vegan options to start your day — just let us know of any allergies or dietary requirements.
        </p>

        <div className="mt-10 divide-y divide-line/60 border-t border-line/60">
          {OPTIONS.map((o, i) => (
            <div
              key={o.name}
              data-testid={`breakfast-option-${i}`}
              className="flex items-center gap-6 py-5 group"
            >
              <o.icon className="w-5 h-5 text-primary shrink-0" strokeWidth={1.5} />
              <div className="flex items-baseline gap-4 flex-wrap">
                <span className="font-serif text-2xl text-textMain group-hover:text-primary transition-colors duration-400">
                  {o.name}
                </span>
                <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-textMuted">
                  {o.note}
                </span>
              </div>
            </div>
          ))}
        </div>

        <Reveal delay={0.1} className="mt-10">
          <Placeholder label="Set for you each morning" src={settingImg} className="aspect-[16/9] w-full max-w-md" parallax testId="breakfast-setting-placeholder" />
        </Reveal>
      </Reveal>

      <Reveal delay={0.12} className="lg:col-span-6 order-1 lg:order-2">
        <div className="relative bg-[#F5EFE6] rounded-sm p-3 md:p-4 shadow-[0_30px_80px_-20px_rgba(0,0,0,0.6)] max-w-md mx-auto cursor-zoom-in group" onClick={() => lightbox?.open(menuImg, "Continental breakfast menu")}>
          <img
            src={menuImg}
            alt="The Old Pub Cellar breakfast menu — Continental, Vegetarian and Vegan"
            className="w-full h-auto rounded-sm transition-transform duration-500 group-hover:scale-[1.02]"
            data-testid="breakfast-menu-image"
          />
        </div>
      </Reveal>
    </div>

    <div className="max-w-7xl mx-auto px-6 md:px-12 mt-8 md:mt-12">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
        <Reveal>
          <Placeholder src={coffeeImg} label="Premium coffee machine" className="aspect-[4/3] w-full" parallax testId="breakfast-coffee-placeholder" />
        </Reveal>
        <Reveal delay={0.08}>
          <Placeholder src={teaImg} label="Tea & coffee station" className="aspect-[4/3] w-full" parallax testId="breakfast-tea-placeholder" />
        </Reveal>
        <Reveal delay={0.16}>
          <Placeholder src={kitchenetteImg} label="Well-stocked kitchenette" className="aspect-[4/3] w-full" parallax testId="breakfast-kitchenette-placeholder" />
        </Reveal>
      </div>
    </div>
  </section>
  );
};
